import React, { useEffect, useState } from 'react'
import Tools from '../../cvp-webgames-core/Misc/Tools';
import { constants } from '../../misc/constants';
import { generalAudioCaching, getGlobalTextSizeStyle, PageType, parseDynamicHtml, setFocus, TextHtmlTagType } from '../../misc/tools';
import { BaseConfig } from '../BaseConfig';
import Button2 from '../general/button2';
import PopUp2 from '../general/pop-up2';
import { UIProperties } from '../../cvp-webgames-core/Components/ui/UIProperties';
import "./feedback-ui.css"
import { GeneralQuestionUIConfigOption } from '../../cvp-webgames-core/Components/ui/react/core-general-question-ui';
import { coreGeneralFeedbackUIBaseImplementation, CoreGeneralFeedbackUIConfig } from '../../cvp-webgames-core/Components/ui/react/core-general-feedback-ui';
import MentorUI from './mentor-ui';
import MediaControlsUI from './media-controls-ui';
const mediaId = Tools.generateGuid()

const FeedbackUI = (props: UIProperties<FeedbackUIConfig>) => {
	const baseImplementation = coreGeneralFeedbackUIBaseImplementation.getImplementation(props.parameters);
	const [isInit, setIsInit] = useState(false);
	const [maximizeImage, setMaximizeImage] = useState(false);
	const [descText, setDescText] = useState(false);
	useEffect(() => {
		if(!isInit) {
			setIsInit(true);

			const url = generalAudioCaching.getItemByKey(generalAudioCaching.audioKeys.music_marimba_chord_01).src;
			Tools.playOneShotSound(url);
		}
	}, []);

	const renderMainWindow = () => {
		return(
			<div className='feedback-ui-sub-container main-content-inner center-element-horizontal'>
							<div className='feedback-ui-sub-container-inner'>
								<div className='feedback-ui-mentor'>
									<MentorUI mediaId={mediaId} talkingVideoSrc={props.parameters.talkVideoUrl} chapterId={props.parameters.talkVideoChapterId}></MentorUI>
								</div>
								<div className='center-element-horizontal feedback-ui-sub-container-question-title'>
									<p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}}className='center-element default-text text-manual-edit-p'>You Selected</p>
								</div>
								
								<div aria-label={props.parameters.selectedOption.title} className='feedback-ui-sub-container-question-single-option' key={Tools.generateGuid()}>
									<Button2 width= '100%'
										idFor508={props.parameters.imgUrl ? '' : 'feedback-content-top'}
										height= '100%'
										onClick= {() => {}}
										hoverBgColor={constants.design.hoverColor2}
										onRenderContent= {() => {
											return (
												<p className='small-text center-element default-text text-manual-edit-p' style={{
													top: '0',
													left: '0',
													transform: 'unset',
													...getGlobalTextSizeStyle(TextHtmlTagType.p)
												}}>{props.parameters.selectedOption.title}</p>
											)
										}}
										isSelected= {false}
										isDisabled={true}
										backgroundColor='rgb(55, 70, 104)'
										ariaLabel= {''}></Button2>
								</div>

								{props.parameters.imgUrl ? <div className='feedback-ui-img'>
									<img id='feedback-content-top' tabIndex={0} src={props.parameters.imgUrl} onKeyUp={Tools.mapDivEnterToClick} onClick={() => {
										setMaximizeImage(true);
										setFocus('feedback-max-img');
									}} aria-label='Select to view Image' />
								</div> : null}

								<div className='feedback-ui-sub-container-desc-container'>
									<div className='center-element-horizontal main-content-inner-nob feedback-ui-sub-container-desc-container-inner default-text text-manual-edit-p' dangerouslySetInnerHTML={{ __html: parseDynamicHtml(props.parameters.selectedOption.feedbackHtml) }}>
									</div>
								</div>
								<div style={{
									width: '990px',
									height: '100px',
									position: 'absolute',
									top: '460px',
									left: '50%',
									transform: 'translatex(-50%)'
								}}>
									<MediaControlsUI mediaId={mediaId}></MediaControlsUI>
								</div>
							</div>
							<div className='center-element-horizontal feedback-ui-sub-container-question-submit'>
								<Button2 width= '100%'
									height= '100%'
									idFor508='feedback-content-bottom'
									onClick= {props.parameters.onButtonClicked}
									onRenderContent= {() => {
										return (
											<p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}}className='small-text center-element default-text text-manual-edit-p'>{'Continue'}</p>
										)
									}}
									isSelected= {false}
									hoverBgColor={constants.design.hoverColor2}
									isDisabled={false}
									ariaLabel= {'Continue'}></Button2>
							</div>
							
						</div>
		)
	}

	const renderMaximizedWindow = () => {
		return(
			<div className='feedback-ui-sub-container main-content-inner center-element-horizontal' style={{
				height: '560px'
			}}>
							<div className='feedback-ui-sub-container-inner'>
								{props.parameters.imgUrl ? <div className='feedback-ui-img-max'>
									<img src={props.parameters.imgUrl} 
									aria-label={`
										Diagram of Repetitive Occurrences of: Human Error / At Risk Behavior / Reckless Behavior. 
										Please refer to D-link text for more details.
								`}/>
								</div> : null}
							</div>
							<div>
								<div className='feedback-ui-back'>
									<Button2 width= '100%'
										idFor508='feedback-max-img'
										height= '100%'
										onClick= {() => {
											setMaximizeImage(false);
											setFocus('feedback-content-top');
										}}
										onRenderContent= {() => {
											return (
												<p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='small-text center-element default-text text-manual-edit-p'>{'Back'}</p>
											)
										}}
										hoverBgColor={constants.design.hoverColor2}
										isSelected= {false}
										isDisabled={false}
										ariaLabel= {'Back'}></Button2>
								</div>
								<div className='feedback-ui-dlink'>
									<Button2 width= '100%'
										height= '100%'
										onClick= {() => {
											setFocus('feedback-description-text');
											setDescText(true);
										}}
										onRenderContent= {() => {
											return (
												<p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='small-text center-element default-text text-manual-edit-p'>{'Description Text'}</p>
											)
										}}
										hoverBgColor={constants.design.hoverColor2}
										isSelected= {false}
										isDisabled={false}
										ariaLabel= {'Select to view Description Text for Image'}></Button2>
								</div>
							</div>
							
						</div>
		)
	}

	const renderDescTextWindow = () => {
		return(
			<div className='feedback-ui-sub-container main-content-inner center-element-horizontal' style={{
				height: '560px'
			}}>
							<div className='feedback-ui-sub-container-inner'>
								{props.parameters.imgUrl ? <div className='feedback-ui-desc-text'>
									<h1 style={{...getGlobalTextSizeStyle(TextHtmlTagType.h1)}} className='black-text default-text text-manual-edit-h1'>Description Text</h1><br/>
									<p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='black-text default-text text-manual-edit-p'>
										Branching graph begins with start. 
										From Branch start, question is "Are there behavior choices that are causing the repitive occurrences?" 
										From Yes, next question is "Will employee make better choices?" 
										From Yes, final branch states "Coach employee to make better choices." 
										From previous question No, final branch states "Consider disciplinary action." 
										Back to start, from No, next question is "Are there system performance shaping factors?" 
										From Yes, then final branch is "Consider System Re-design." 
										From No, next question is "Are there personal performance shaping factors?" 
										From No, then final branch is "Consider Re-assignment or disciplinary action." 
										From Yes, next question is "Will employee address these factors?" 
										From No, then final branch is "Consider Re-assignment or disciplinary action." 
										From Yes, then final branch is "Coach employee to remedy personal performance shaping factors." 
										Footer of image reads "Adapted from Just Culture Training for Managers - Healthcare edition. Adapted and modified from: Outcome Engenuity 2012
									</p>
								</div> : null}
							</div>
							<div className='center-element-horizontal feedback-ui-sub-container-question-submit'>
								<Button2 width= '100%'
									idFor508='feedback-description-text'
									height= '100%'
									onClick= {() => {
										setFocus('feedback-max-img');
										setDescText(false)
									}}
									onRenderContent= {() => {
										return (
											<p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='small-text center-element default-text text-manual-edit-p'>{'Back'}</p>
										)
									}}
									hoverBgColor={constants.design.hoverColor2}
									isSelected= {false}
									isDisabled={false}
									ariaLabel= {'Back'}></Button2>
							</div>
							
						</div>
		)
	}
	
	return (
		<div aria-label='feedback' className={`modal-disable-select center-element feedback-ui-container ${constants.mainContent508Id}`} style={{
		}}>
			<PopUp2
				titleLeft= {constants.projectTitle}
				titleRight= {props.parameters.title}
				subtitleRight= {props.parameters.subtitle + ' - Feedback'}
				onRenderContent={() => {
					return maximizeImage ? (descText ? renderDescTextWindow() : renderMaximizedWindow()) : renderMainWindow();
				}}></PopUp2>
		</div>
	);

};

export interface FeedbackUIConfig extends CoreGeneralFeedbackUIConfig {
	subtitle: string;
	imgUrl?: string;
	talkVideoUrl: string;
	talkVideoChapterId: string;
}

export default FeedbackUI;